<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-product-list' })"
          >Back to Product</vs-button>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
            @click="Add"
          >Save Product</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div slot="no-body" class="p-3">
        <smsc-col>
          <smsc-col-item col-quantity="2" mt="0">
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input"
              class="w-100 deep"
              :class="{'is-danger': errors.has('Product Name')}"
              name="Product Name"
              label="Product Name"
              placeholder="Enter product name"
              v-model="payload.product_name"
            />
            <span class="text-danger text-xs">{{ errors.first('Product Name') }}</span>
          </smsc-col-item>

          <smsc-col-item col-quantity="2" mt="0">
            <label class="vs-input--label">Status</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              name="status"
              placeholder="Enter status"
              :class="{'is-danger': errors.has('status')}"
              label="name"
              :reduce="(option) => option.value"
              :options="statusTypes"
              v-model="payload.status"
            />
            <span class="text-danger text-xs">{{ errors.first('status') }}</span>
          </smsc-col-item>
          <smsc-col-item  col-quantity="2" mt="0">
            <label class="vs-input--label">Type</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              class="deep"
              name="type"
              placeholder="Enter type"
              :class="{'is-danger': errors.has('type')}"
              :options="types"
              :reduce="(option) => option.value"
              v-model="payload.public"
            />
            <span class="text-danger text-xs">{{ errors.first('type') }}</span>
          </smsc-col-item>
        </smsc-col>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Packages
import axios from '@/axios.js'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      // Dropdowns
      statusTypes: [{name: 'Active', value: 'active'}, {name: 'Inactive', value: 'inactive'}],
      types: [{label: 'Public', value: true}, {label: 'Private', value: false}],
      product_name:"",
      uuid:"",
      list:[],
      payload: {},
      selected:{},
    }
  },
  created() {
    this.FetchData()
  },
  methods: {
    Add(){
      let params = {
        data:{
          product_name : this.payload.product_name,
          status : this.payload.status,
          public : this.payload.public
        }
      }
      this.$store.dispatch('product/Add',params).then(()=>{
        this.$router.push({ name: 'Admin-product' })
        this.ShowSuccessMessage({ title: 'Success', text: 'Product has been added' })
      }).catch(()=>{
        this.ShowErrorMessage({ title: 'Error: Failed  to add product'})
      }).finally(()=>{

      })
    },


  /*  async Add() {
      const valid = await this.$validator.validate()

      if (!valid) {
        return
      }
      this.$vs.loading()
      this.$store.dispatch('product/Add', { ...this.payload})
      .then(res => {
        this.$router.push({ name: 'admin-product-list' })
        this.ShowSuccessMessage({ title: 'Success', text: 'Product has been added' })
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },
    async FetchData() {
      this.$vs.loading()
      const { total: TotalForCountry } = await this.$store.dispatch('country/GetList', { per_page: 0 })
      const p1 = await this.$store.dispatch('country/GetList', { per_page: TotalForCountry, order_by: 'nice_name', order_dir: 'asc' })

      Promise.all([p1])
      .then(res => {
        this.countries = res[0].items.map(this.TransformCountry)
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err.response }))
      .finally(() => this.$vs.loading.close())
    },

    // Capitalize
    Capitalize (val) {
      if (!val) return ''

      return `${val.charAt(0).toUpperCase()}${val.slice(1)}`
    },
*/
    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
  /*  TransformCountry(item) {
      return {
        name: item.nice_name,
        value: item.country_uuid
      }
    },*/
  }
}
</script>
<style>
.lab{
    margin-left: 15px;
}
</style>
